import ApprovalCL from "../pages/approval-cl";
import ApprovalLR from "../pages/approval-lr";
import { Bypass } from "../pages/bypass";
import CLSendSK from "../pages/cl-send-sk";
import CreateForm from "../pages/create-form";
import EditFinishCL from "../pages/edit-finish-cl";
import EditForm from "../pages/edit-form";
import Questionnaire from "../pages/questionnaire";
import ViewForm from "../pages/view-form";
import CrrReport from "../presentation/CrrReport";
import HomePageRevamped from "../presentation/Home";
import ListOfRequestRevamped from "../presentation/ListOfRequest";
import MasterRoleRevamped from "../presentation/MasterRole";
import MasterUserRevamped from "../presentation/MasterUser";
import QuestionnaireReport from "../presentation/QuestionnaireReport";
import { Route } from "../types/route";

export const protectedRoutes: Route[] = [
  {
    key: "HomePages",
    title: "HomePages",
    access: "Home",
    component: HomePageRevamped,
    path: "/",
    isEnabled: true,
    appendDivider: true,
  },
  {
    key: "BypassLogin",
    title: "BypassLogin",
    access: "Home",
    component: Bypass,
    path: "/bypass",
    isEnabled: true,
    appendDivider: true,
  },
  {
    key: "CreateForm",
    title: "CreateForm",
    access: "Home",
    component: CreateForm,
    path: "/form",
    isEnabled: true,
    appendDivider: true,
  },
  {
    key: "ViewForm",
    title: "ViewForm",
    access: "Home",
    component: ViewForm,
    path: "/view/:id",
    isEnabled: true,
    appendDivider: true,
  },
  {
    key: "EditForm",
    title: "EditForm",
    access: "Home",
    component: EditForm,
    path: "/edit/:id",
    isEnabled: true,
    appendDivider: true,
  },
  {
    key: "ApprovalCL",
    title: "ApprovalCL",
    access: "Home",
    component: ApprovalCL,
    path: "/approvalcl/:id",
    isEnabled: true,
    appendDivider: true,
  },
  {
    key: "EditFinishCL",
    title: "EditFinishCL",
    access: "Home",
    component: EditFinishCL,
    path: "/editfinishcl/:id",
    isEnabled: true,
    appendDivider: true,
  },
  {
    key: "ApprovalLR",
    title: "ApprovalLR",
    access: "Home",
    component: ApprovalLR,
    path: "/approvallr/:id",
    isEnabled: true,
    appendDivider: true,
  },
  {
    key: "CLSendSK",
    title: "CLSendSK",
    access: "Home",
    component: CLSendSK,
    path: "/clsendsk/:id",
    isEnabled: true,
    appendDivider: true,
  },
  {
    key: "Master User",
    title: "Master User",
    access: "Master User",
    component: MasterUserRevamped,
    path: "/master-user",
    isEnabled: true,
    appendDivider: true,
  },
  {
    key: "Master Role",
    title: "Master Role",
    access: "Master Role",
    component: MasterRoleRevamped,
    path: "/master-role",
    isEnabled: true,
    appendDivider: true,
  },
  {
    key: "List of Request",
    title: "List of Request",
    access: "List of Request",
    component: ListOfRequestRevamped,
    path: "/list-of-request",
    isEnabled: true,
    appendDivider: true,
  },
  {
    key: "CRR Report",
    title: "CRR Report",
    access: "CRR Report",
    component: CrrReport,
    path: "/crr-report",
    isEnabled: true,
    appendDivider: true,
  },
  {
    key: "Questionnaire",
    title: "Questionnaire",
    access: "Home",
    component: Questionnaire,
    path: "/questionnaire/:id",
    isEnabled: true,
    appendDivider: true,
  },
  {
    key: "Questionnaire Report",
    title: "Questionnaire Report",
    access: "Home",
    component: QuestionnaireReport,
    path: "/questionnaire-report",
    isEnabled: true,
    appendDivider: true,
  },
];
